module.exports = __webpack_public_path__ + "img/Weapon_265.bb53aa51.png";